module.cC({
    name: 'JobPlacementController',
    inject: ['$scope', '$state', 'placement', 'ModelService'],

    data: {
        placement: 'placement',
        forms: '{}',
    },

    methods: {
        deletePlacement: function() {
            this.ModelService.deleteModel(this.placement)
                .then(this.$state.go.bind(this.$state, 'placementIndex'));
        },
    },
});